import { classNames } from '@bambi/component-library/src/utils/classNames';
import { type PropsWithChildren } from 'react';

/**
 * Display component to wrap a section within an inset well
 */
export interface WellProps extends PropsWithChildren {
  testId?: string;
  skipPrintable?: boolean;
  // Additional classNames to pass
  className?: string;
}
export function Well({
  children,
  testId,
  skipPrintable,
  className,
}: WellProps) {
  return (
    <>
      <div
        data-testid={testId}
        className={classNames(
          `mt-4 flex w-full flex-col gap-2 rounded border border-slate-300 bg-gray-100 p-4 print:hidden`,
          className
        )}
      >
        {children}
      </div>
      {skipPrintable ? null : <div className="screen:hidden">{children}</div>}
    </>
  );
}

export function WellTitleSection({ children }: PropsWithChildren) {
  return (
    <div className="relative">
      {children}
      <div className="absolute -left-4 -right-4 border-b border-slate-300 pt-2"></div>
      <div className="pt-2"></div>
    </div>
  );
}
